// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1518":"4c28caa534500df1","4301":"8d796e2963df4ebb","5428":"6179019038f0be40","9812":"174503a7afb4b45a"}[chunkId] + ".js";
};